import React, { useEffect, useState } from 'react';
import { Form, Select, message } from 'antd';
import axios from 'axios';
import { apiUrl } from '../../common/url';
import * as Sentry from '@sentry/react';

interface DataCollTableNames {
  data_coll: string[];
  data_coll_basis_upload: string[];
  data_coll_basis: string[];
  data_coll_backup: string[];
}

interface DataCollSelectionProps {
  client: { id: string; name?: string; token: string; permissions: string[] };
  dataCollName?: string;
  setDataCollName: React.Dispatch<React.SetStateAction<string | undefined>>;
  setHasBasisUploadTable: React.Dispatch<React.SetStateAction<boolean>>;
  setHasBasisTable: React.Dispatch<React.SetStateAction<boolean>>;
  setHasBackupTable: React.Dispatch<React.SetStateAction<boolean>>;
  setAllDiffsApplied: React.Dispatch<React.SetStateAction<boolean>>;
  setAllStructuralMappingsApplied: React.Dispatch<React.SetStateAction<boolean>>;
}

// TODO: replace with year selection (at least the parts the user sees.)
const DataCollSelection: React.FC<DataCollSelectionProps> = ({
  client,
  dataCollName,
  setDataCollName,
  setHasBasisUploadTable,
  setHasBasisTable,
  setHasBackupTable,
  setAllDiffsApplied,
  setAllStructuralMappingsApplied,
}) => {
  const [dataCollNames, setDataCollNames] = useState<{ label: string; value: string }[]>([]);
  // const [customDataCollName, setCustomDataCollName] = useState<string | undefined>(undefined);
  const [dataCollBasisUploadTables, setDataCollBasisUploadTables] = useState<string[]>([]);
  const [dataCollBasisTables, setDataCollBasisTables] = useState<string[]>([]);
  const [dataCollBackupTables, setDataCollBackupTables] = useState<string[]>([]);

  const getDataCollNames = () => {
    axios
      .get(`${apiUrl}/b2zero/${client.id}/get_data_coll_tables`, {
        headers: { Authorization: `Bearer ${client.token}` },
      })
      .then((response) => {
        const { data_coll, data_coll_basis_upload, data_coll_basis, data_coll_backup } =
          response.data as DataCollTableNames;
        setDataCollNames(
          data_coll.sort().map((table_name: string) => ({
            label: table_name,
            value: table_name,
          }))
        );
        setDataCollBasisUploadTables(data_coll_basis_upload);
        setDataCollBasisTables(data_coll_basis);
        setDataCollBackupTables(data_coll_backup);

        // Use local variables for the check
        const lastValue = data_coll.length > 0 ? data_coll[data_coll.length - 1] : undefined;
        setDataCollName(lastValue);
        setHasBasisUploadTable(
          lastValue ? (data_coll_basis_upload || []).includes(`${lastValue}_basis_upload`) : false
        );
        setHasBasisTable(
          lastValue ? (data_coll_basis || []).includes(`${lastValue}_basis`) : false
        );
        setHasBackupTable(
          lastValue ? (data_coll_backup || []).includes(`${lastValue}_backup`) : false
        );
      })
      .catch((error) => {
        message.error(
          'Fehler beim Abrufen der vorhandenen data_coll Tabellen: ' + error.message,
          3
        );

        Sentry.withScope((scope) => {
          scope.setLevel('warning');
          scope.setExtra(
            'hint',
            'Fehler beim Abrufen der vorhandenen data_coll Tabellen: ' + error.message
          );
          Sentry.captureException(error);
        });
        return [];
      });
  };

  useEffect(() => {
    getDataCollNames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client.id]);

  const handleChangeDataCollName = (value: string | undefined) => {
    setDataCollName(value);
    setHasBasisUploadTable(
      value ? dataCollBasisUploadTables.includes(`${value}_basis_upload`) : false
    );
    setHasBasisTable(value ? dataCollBasisTables.includes(`${value}_basis`) : false);
    setHasBackupTable(value ? dataCollBackupTables.includes(`${value}_backup`) : false);
    setAllDiffsApplied(false);
    setAllStructuralMappingsApplied(false);
  };

  // const validateCustomDataCollName = (_: any, value: string) => {
  //   if(value === undefined || value === "") {
  //     return Promise.resolve();
  //   }
  //   if (!value.startsWith(`c${client.id}_data_coll`)) {
  //     return Promise.reject(new Error(`Der Name muss mit "c${client.id}_data_coll" beginnen.`));
  //   }
  //   if (dataCollNames.some(name => name.value === value)) {
  //     return Promise.reject(new Error('Der Name darf nicht bereits existieren.'));
  //   }
  //   return Promise.resolve();
  // };

  return (
    <Form>
      <Form.Item label="Wählen Sie die zu bearbeitende Stammdatentabelle, das Jahr beschreibt dabei das Bilanzierungsjahr">
        <Select
          placeholder="Bitte wählen Sie die zu bearbeitende Stammdatentabelle, das Jahr beschreibt dabei das Bilanzierungsjahr."
          style={{ width: 200 }}
          onChange={handleChangeDataCollName}
          value={dataCollName}
          options={dataCollNames}
          // disabled={customDataCollName !== undefined && customDataCollName !== ""}
        />
      </Form.Item>
      {/* <Form.Item label="Oder bennen Sie die neu zu erstellende data_coll Tabelle"
    name="customDataCollName"
    rules={[{ validator: validateCustomDataCollName }]}
    >
       <Input
        placeholder={`${client.id}_data_coll_YYYY`}
        style={{ width: 200, marginTop: 8 }}
        onChange={(e) => setCustomDataCollName(e.target.value)}
        value={customDataCollName}
        allowClear
      />
      </Form.Item> */}
    </Form>
  );
};

export default DataCollSelection;
